export function getImageSrc(source) {
  if (!source) return '';
  if (typeof source === 'string') return source;
  return source.fallback;
}

function getMimeType(filePath) {
  if (/\.jpe?g($|\?)/i.test(filePath)) return 'image/jpeg';
  return 'image/png';
}

export function heroBackgroundStyle(asset) {
  const webp = typeof asset === 'string' ? asset : asset.webp;
  const fallback = typeof asset === 'string' ? asset : asset.fallback;

  return {
    '--hero-bg': `image-set(url("${webp}") type("image/webp"), url("${fallback}") type("${getMimeType(fallback)}"))`,
  };
}
